export const AllProductListTableColumns = {
    PRODUCT_NAME: 'Product Name',
    IN_REVIEW: 'In Review',
    VERIFIED: 'Approved',
    DRAFT: 'Draft',
    DECLINED: 'Declined',
    TOTAL: 'Total',
  };

  export enum AllProductListTableFields {
    NAME = 'name',
    DRAFT = 'draft',
    TOTAL = 'total',
    IN_REVIEW = 'inReview',
    APPROVED = 'approved',
    DECLINED = 'declined',
    IN_REVIEW_KEY = 'in_review',
    ASC = 'ASC',
    DESC = 'DESC',
  }